import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchUsers, deleteUser, sendInvit } from '../../actions/user';

//const currentUser = JSON.parse(localStorage.getItem("user"));

class UserItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      invitSent:false
    };
  }

  handleDelete(elm) {
    var result = window.confirm("Voulez vous vraiment supprimer cet utilisateur?");
    if (result) {
      this.props.deleteUser(this.props.id)
    }
  }

  sendInvit(elm) {
    var result = window.confirm("Voulez vous vraiment renvoyer un lien d'initialisation à cet utilisateur?");
    if (result) {
      this.props.sendInvit(this.props.id)
    }
  }

  UNSAFE_componentWillReceiveProps(NextProps){
    if(NextProps.message === 'User successfully removed!'){
      this.props.fetchUsers();
    }
    if(NextProps.message === this.props.id+' : successfully updated!' && this.state.invitSent === false){
      this.setState({
        invitSent:true
      })
    }
  }

  render() {
    return (
      <div className="line">
        <Link className="" to={"/user/"+this.props.id}>
          {!this.props.active ? (
            <i className="far fa-clock" style={{marginRight:"10px", marginLeft:"10px"}}></i>
          ) : (
            <i className="fas fa-check-circle" style={{color:'#8BC34A', marginRight:"10px", marginLeft:"10px"}}></i>
          )}
          <i className="fas fa-user" style={{marginRight:"10px"}}></i>
          <p style= {{width: 'calc(100% - 410px)'}}> {this.props.firstname} {this.props.lastname} - {this.props.timestamp}</p>
        </Link>
        <div className="tools">
          {!this.props.active && this.state.invitSent === false ? (
            <span onClick={this.sendInvit.bind(this)} className="message-remove"><i className="fas fa-envelope" style={{marginRight:"10px", marginLeft:"10px"}}></i> {this.props.email}</span>
          ) : (
            null
          )}
          {!this.props.active && this.state.invitSent === true ? (
            <span>Invitation sent !</span>
          ) : (
            null
          )}
          {/*currentUser && currentUser._id !== this.props.id ? (
            <a onClick={this.handleDelete.bind(this)} className="Message-remove"><MaterialIcon icon="delete" /></a>
          ) : (
          null
        )*/}
        </div>
      </div>
    );

  }
}

function mapStateToProps(state) {
  return {
    message:state.user.message
  };
}

export default connect(mapStateToProps, { fetchUsers,deleteUser, sendInvit })(UserItem);
